import { ChangeDetectorRef, Component } from '@angular/core';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models/index';

@Component({
    templateUrl: './yes-no.component.html',
    standalone: false
})
export class InstallationYesNoPluginComponent {
  public questions: any[];
  public config: any;
  public editRoute = ['installation', 'yesno', 'edit'];

  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }
  private initData() {
    if (this.config.Questions?.length) {
      this.questions = this.config.Questions;
    } else {
      this.questions = this.config.YesNo ? [this.config.YesNo] : [];
    }
  }
}
PluginComponent.plugins['installationyesno'] = InstallationYesNoPluginComponent;
